<template>
  <div class="recommendation-rating">
    <div v-for="index in 5" :key="index">
      <svg
        v-if="props.iconType === 'savings' && currency === 'GBP'"
        id="_x32_"
        width="60"
        height="60"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xml:space="preserve"
        :class="index <= props.rating ? 'color-icon' : 'blank-icon'"
      >
        <path
          d="M220.394,321.017c0-5.901,0-5.303,0-19.83h118.494v-69.122H220.394c0-23.533,0-44.983,0-56.786
          c0-10.028,1.991-19.315,5.593-27.858c5.394-12.78,14.536-23.804,25.994-31.534c11.494-7.73,24.98-12.182,39.987-12.2
          c10.046,0.018,19.314,2.009,27.858,5.612c12.78,5.394,23.822,14.535,31.552,25.994c7.349,10.934,11.694,23.731,12.11,37.895
          l100.936-29.044c-2.317-12.888-5.992-25.351-10.97-37.108c-13.342-31.514-35.498-58.179-63.447-77.059
          C362.113,11.078,328.1-0.009,291.968,0c-24.057,0-47.228,4.906-68.226,13.803c-31.533,13.35-58.198,35.488-77.078,63.446
          c-18.898,27.904-29.976,61.908-29.958,98.03c0,11.803,0,33.253,0,56.786H47.576v69.122h69.131c0,14.527,0,26.184,0,32.085
          c0.018,7.675-0.995,18.202-3.403,28.519c-1.792,7.766-4.362,15.432-7.494,22.03c-2.335,4.969-4.978,9.323-7.73,12.879
          c-4.181,5.359-8.308,8.816-13.033,11.278c-2.389,1.232-4.996,2.245-8.254,3.023c-3.222,0.76-15.731,1.267-20.564,1.267V512h398.673
          v-99.732H170.686C181.384,405.698,220.394,370.978,220.394,321.017z"
        />
      </svg>
      <svg
        v-else-if="props.iconType === 'savings'"
        x="0px"
        y="0px"
        width="60"
        height="60"
        viewBox="0 0 291.929 291.929"
        :class="index <= props.rating ? 'color-icon' : 'blank-icon'"
      >
        <path
          d="M264.95,191.544h-42.461c-9.537,0-10.403,3.957-11.689,12.427
                    c-3.474,20.405-22.958,32.887-46.354,32.887c-26.861,0-48.479-21.135-50.22-45.379h60.04c7.367,0,12.564-2.544,12.564-12.327
                    V166.99c0-9.756-5.197-12.017-12.564-12.017h-60.468v-18.126h60.468c7.367,0,12.564-2.535,12.564-12.327v-12.163
                    c0-9.765-5.197-12.327-12.564-12.327h-59.602c3.036-22.101,23.934-45.388,49.5-45.388c23.396,0,36.662,9.218,45.78,23.241
                    c3.465,5.106,3.902,13.166,13.002,13.166h41.877c9.966,0,13.439-3.556,13.439-13.74C272.627,23.35,219.061,0,165.321,0
                    C114.217,0,51.095,34.583,49.791,100.021h-23.56c-7.786,0-12.564,2.544-12.564,12.327v12.163c0,9.774,4.769,12.327,12.564,12.327
                    H41.22v18.117H26.231c-7.786,0-12.564,2.544-12.564,12.327v11.88c0,9.756,4.769,12.327,12.564,12.327h23.533v1.714
                    c0,66.705,63.131,98.726,114.682,98.726c53.739,0,113.496-32.267,113.496-87.101C277.942,194.634,274.478,191.544,264.95,191.544z"
        />
      </svg>

      <svg
        v-if="props.iconType === 'comfort'"
        x="0px"
        y="0px"
        width="60"
        height="60"
        viewBox="0 0 579.496 579.496"
        :class="index <= props.rating ? 'color-icon' : 'blank-icon'"
      >
        <path
          d="M565.41,199.958c-0.869-3.237-3.023-5.385-6.475-6.469l-94.48-31.053V63.421c0-3.452-1.407-6.242-4.211-8.415
                    c-3.237-2.148-6.364-2.577-9.382-1.292l-94.48,30.411L298.144,3.892C296.216,1.297,293.407,0,289.741,0
                    c-3.672,0-6.469,1.303-8.415,3.892l-58.238,80.233l-94.48-30.411c-3.023-1.291-6.145-0.856-9.382,1.292
                    c-2.803,2.173-4.204,4.969-4.204,8.415v99.016L20.546,193.49c-3.452,1.089-5.612,3.237-6.475,6.469
                    c-1.083,3.464-0.643,6.585,1.292,9.388l58.244,80.233l-58.244,80.245c-1.94,2.589-2.375,5.723-1.292,9.388
                    c0.863,3.238,3.017,5.398,6.475,6.47l94.48,31.053v99.021c0,3.451,1.401,6.242,4.205,8.402c3.237,2.16,6.365,2.589,9.382,1.304
                    l94.48-30.423l58.238,80.246c2.154,2.803,4.963,4.21,8.415,4.21c3.446,0,6.255-1.401,8.416-4.21L356.4,495.04l94.48,30.423
                    c3.017,1.291,6.145,0.856,9.382-1.304c2.803-2.16,4.211-4.957,4.211-8.402v-99.016l94.48-31.053
                    c3.445-1.077,5.605-3.237,6.475-6.469c1.077-3.666,0.643-6.8-1.291-9.389l-58.244-80.245l58.244-80.233
                    C566.06,206.544,566.487,203.422,565.41,199.958z M461.389,361.899c-9.816,22.981-23.078,42.822-39.798,59.529
                    c-16.714,16.732-36.562,29.994-59.536,39.799c-22.974,9.822-47.074,14.725-72.314,14.725c-25.239,0-49.339-4.902-72.314-14.725
                    c-22.975-9.811-42.822-23.066-59.535-39.799c-16.714-16.707-29.982-36.555-39.798-59.529
                    c-9.817-22.974-14.719-47.081-14.719-72.319c0-25.227,4.902-49.34,14.719-72.308c9.816-22.98,23.078-42.809,39.798-59.542
                    c16.713-16.708,36.561-29.982,59.535-39.786c22.968-9.81,47.075-14.725,72.314-14.725c25.24,0,49.34,4.915,72.314,14.725
                    c22.969,9.811,42.816,23.079,59.536,39.786c16.713,16.732,29.981,36.567,39.798,59.542c9.816,22.962,14.725,47.081,14.725,72.308
                    C476.113,314.818,471.199,338.926,461.389,361.899z"
        />
        <circle cx="289.741" cy="289.745" r="157.768" />
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getCurrency } from "@/helpers";
const props = defineProps({
  rating: {
    type: Number,
    required: true,
  },
  iconType: {
    type: String as () => "savings" | "comfort",
    required: true,
  },
});
const currency = getCurrency();
</script>

<style lang="scss" scoped>
.recommendation-rating {
  display: flex;
  align-items: center;
  svg {
    width: 1.2rem;
    margin: 1px;
  }
}
.savings-detail,
.comfort-detail {
  display: flex;
  svg {
    width: 1.2rem;
    margin: 1px;
  }
}
</style>
